import {useReturnTo} from "../../../../hooks/useReturnTo.ts";
import {SignUpForm} from "../forms/SignUpForm.tsx";
import {LinkToSignInPage} from "../../sign-in/components/LinkToSignInPage.tsx";
import {SignUpPageGrid} from "../components/SignUpPageGrid.tsx";
import {LinkToConfirmSignUpPage} from "../components/LinkToCofnirmSignUpPage.tsx";
import {useAuth} from "../../../../hooks/useAuth.ts";
import {
    useNavigate,
    useSearchParams
} from "react-router-dom";
import {useEffect} from "react";
import {IndexPage as MarketingPage} from "../../../marketing/pages/IndexPage";

import {Cache} from 'aws-amplify/utils';

export const IndexPage = () => {
    const [searchParams,] = useSearchParams()

    // Support both productId (new) and plan (legacy) parameters
    const productId = searchParams.get('productId')
    const plan = searchParams.get('plan')
    
    // Store the selected product/plan ID
    const selectedId = productId || plan
    if (selectedId) {
        Cache.setItem('flexinet-selected-product-id', selectedId)
        // Keep legacy cache key for backward compatibility
        Cache.setItem('flexinet-selected-plan-id', selectedId)
    }

    const navigate = useNavigate()

    const {
        saveReturnTo,
    } = useReturnTo()

    saveReturnTo()

    const {user} = useAuth()
    useEffect(
        () => {
            if (user) {
                navigate('/dashboard')
            }
        }, [user, navigate]
    )


    const leftPanel = <>
        <SignUpForm/>
        <LinkToConfirmSignUpPage/>
        <LinkToSignInPage/>
    </>

    return (
        <SignUpPageGrid leftPanel={leftPanel} rightPanel={<MarketingPage/>}/>
    );


}
